import { SovosAvatar, SovosBox, SovosTypography } from "mosaic-react";
import React from "react";
const UserAvatar = props => {
  const {
    value: username
  } = props;
  const [firstName, surname] = username.split(" ", 2);
  return /*#__PURE__*/React.createElement(SovosBox, {
    sx: {
      display: "flex",
      justifyContent: "space-between",
      justifyContent: "center",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(SovosAvatar, {
    name: firstName,
    surname: surname,
    size: "small"
  }), /*#__PURE__*/React.createElement(SovosTypography, {
    sx: {
      marginLeft: "10px"
    },
    children: username
  }));
};
export default UserAvatar;